var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"section-subtitle"},[_c('h2',{staticClass:"robotoBB"},[_vm._t("default")],2),(_vm.$scopedSlots.right)?_c('div',{staticClass:"section-subtitle-right"},[_vm._t("right")],2):_vm._e(),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }